<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h2 class="ct">Contents</h2>
<p class="noindent"><a href="#/xhtml/06_Chapter01">A Dry Welcome</a></p>
<p class="noindent"><a href="#/xhtml/07_Chapter02">Out of the Firing Line</a></p>
<p class="noindent"><span href="#/xhtml/08_Chapter03" title="Link target outside of Sample">A Late Homecoming</span></p>
<p class="noindent"><span href="#/xhtml/09_Chapter04" title="Link target outside of Sample">Warning Skies</span></p>
<p class="noindent"><span href="#/xhtml/10_Chapter05" title="Link target outside of Sample">Together, Separately</span></p>
<p class="noindent"><span href="#/xhtml/11_Chapter06" title="Link target outside of Sample">Too Many Strays</span></p>
<p class="noindent"><span href="#/xhtml/12_Chapter07" title="Link target outside of Sample">One Shot More or Less</span></p>
<p class="noindent"><span href="#/xhtml/13_Chapter08" title="Link target outside of Sample">Counting Sheep</span></p>
<p class="noindent"><span href="#/xhtml/14_Chapter09" title="Link target outside of Sample">The Fortunes of Saints</span></p>
<p class="noindent"><span href="#/xhtml/15_Chapter10" title="Link target outside of Sample">280,000 Bees for Breakfast</span></p>
<p class="noindent"><span href="#/xhtml/16_Chapter11" title="Link target outside of Sample">A Beast’s Love</span></p>
<p class="noindent"><span href="#/xhtml/17_Chapter12" title="Link target outside of Sample">A Cocktail of Toxins</span></p>
<p class="noindent"><span href="#/xhtml/18_Chapter13" title="Link target outside of Sample">A Harvest, at Last</span></p>
<p class="noindent"><span href="#/xhtml/19_Chapter14" title="Link target outside of Sample">Blessed June</span></p>
<p class="noindent"><span href="#/xhtml/04_Acknowledgements" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="noindent"><span href="#/xhtml/Abouttheauthor" title="Link target outside of Sample"><i>About the Author</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?723757fa